import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../landing/Header';
import Footer from '../landing/Footer';
import { useSEO } from '../../hooks/useSEO';

export default function LegalPage({ title, pageTitle, description, path, children }) {
  const navigate = useNavigate();
  useSEO({
    title: pageTitle || `${title} | Conadvy`,
    description: description || `${title} de Conadvy — Plataforma de advisory estratégico.`,
    path: path || '',
  });

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#F5F5F3]">
      <Header variant="subpage" />
      <article className="pt-32 pb-24 md:pt-36 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <button
            onClick={() => navigate(-1)}
            className="text-[#8A9BB1] text-xs uppercase tracking-wider hover:text-[#00163E] transition-colors mb-8 block"
          >
            &larr; Volver
          </button>
          <h1 className="text-2xl md:text-3xl font-normal text-[#00163E] mb-4">{title}</h1>
          <div className="h-[1px] w-12 bg-[#C58C40]/40 mb-10" />
          <div className="legal-content space-y-6 text-[#00163E]/80 text-sm leading-relaxed">
            {children}
          </div>
        </div>
      </article>
      <Footer />
    </div>
  );
}
